import { render } from "./TableHome.vue?vue&type=template&id=2bcb3d34&scoped=true"
import script from "./TableHome.vue?vue&type=script&lang=js"
export * from "./TableHome.vue?vue&type=script&lang=js"

import "./TableHome.vue?vue&type=style&index=0&id=2bcb3d34&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcb3d34"]])

export default __exports__